import { DEFAULT_PRODUCT_IMAGE_BASE64 } from '@epilot/concorde-elements'
import type { ComponentProps } from 'react'

import { ProductImageCommon } from './ProductImageCommon'

export const DefaultProductImage = ({
  ...props
}: Omit<ComponentProps<typeof ProductImageCommon>, 'src'>) => (
  <ProductImageCommon src={DEFAULT_PRODUCT_IMAGE_BASE64} {...props} />
)
